export interface Stakeholder {
  id: string;
  name: string;
  type: 'Empresa' | 'Inversor' | 'Investigador';
  sectors: string[];
  lastInteraction: string;
  email?: string;
  phone?: string;
}

export const mockStakeholders: Stakeholder[] = [
  {
    id: 'stake-001',
    name: 'MedTech Innovations S.A.S.',
    type: 'Empresa',
    sectors: ['Salud', 'Tecnología Médica', 'IA'],
    lastInteraction: '2024-10-20T14:30:00Z',
    email: 'contacto@medtech.com',
    phone: '+57 300 123 4567'
  },
  {
    id: 'stake-002',
    name: 'AgroTech Solutions',
    type: 'Empresa',
    sectors: ['Agricultura', 'Blockchain', 'IoT'],
    lastInteraction: '2024-10-15T10:00:00Z',
    email: 'info@agrotech.co',
    phone: '+57 301 234 5678'
  },
  {
    id: 'stake-003',
    name: 'Green Energy Capital',
    type: 'Inversor',
    sectors: ['Energías Renovables', 'Sostenibilidad'],
    lastInteraction: '2024-09-30T16:45:00Z',
    email: 'inversiones@greenenergy.com',
    phone: '+57 302 345 6789'
  },
  {
    id: 'stake-004',
    name: 'Dr. Juan Pérez',
    type: 'Investigador',
    sectors: ['Biotecnología', 'Nanotecnología'],
    lastInteraction: '2024-10-25T09:15:00Z',
    email: 'j.perez@universidad.edu.co',
    phone: '+57 303 456 7890'
  },
  {
    id: 'stake-005',
    name: 'EduTech Ventures',
    type: 'Empresa',
    sectors: ['Educación', 'Realidad Aumentada', 'Software'],
    lastInteraction: '2024-11-02T11:20:00Z',
    email: 'contacto@edutech.co',
    phone: '+57 304 567 8901'
  },
  {
    id: 'stake-006',
    name: 'Construcciones Sostenibles Ltda.',
    type: 'Empresa',
    sectors: ['Construcción', 'Materiales', 'Sostenibilidad'],
    lastInteraction: '2024-10-28T13:00:00Z',
    email: 'ventas@consostenible.com',
    phone: '+57 305 678 9012'
  }
];
